import { render, staticRenderFns } from "./ThePasteRecipientsInputWrapper.vue?vue&type=template&id=004f1388&scoped=true"
import script from "./ThePasteRecipientsInputWrapper.vue?vue&type=script&lang=js"
export * from "./ThePasteRecipientsInputWrapper.vue?vue&type=script&lang=js"
import style0 from "./ThePasteRecipientsInputWrapper.vue?vue&type=style&index=0&id=004f1388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f1388",
  null
  
)

export default component.exports